import { IUserPayload } from "../../types";
import { request } from "../../utils/axios";

export const inviteAdmin = async (form: IUserPayload) => {
  try {
    const res = await request.post(`super-admin/admins/invite`, form);
    return res?.data;
  } catch (error: any) {
    const err = error?.response?.data;
    throw err;
  }
};

export const updateAdmin = async (form: IUserPayload) => {
  try {
    const res = await request.put(`super-admin/admins/${form.id}`, form);
    return res?.data;
  } catch (error: any) {
    const err = error?.response?.data;
    throw err;
  }
};

export const disableAdmin = async (id: number) => {
  try {
    const res = await request.put(`super-admin/admins/${id}/disable`);
    return res?.data;
  } catch (error: any) {
    const err = error?.response?.data;
    throw err;
  }
};

export const restoreAdmin = async (id: number) => {
  try {
    const res = await request.put(`super-admin/admins/${id}/restore`);
    return res?.data;
  } catch (error: any) {
    const err = error?.response?.data;
    throw err;
  }
};


export const fetchUsers = async (page: number | string) => {
  try {
    const res = await request.get(`super-admin/admins?page=${page}`);
    return res?.data;
  } catch (error: any) {
    const err = error?.response?.data;
    throw err;
  }
};

export const fetchEnrolledUsers = async ({
  page,
  id,
}: {
  page: number | string;
  id: number;
}) => {
  try {
    const res = await request.get(`admin/courses/${id}/students?page=${page}`);
    return res?.data;
  } catch (error: any) {
    const err = error?.response?.data;
    throw err;
  }
};
